import React from 'react'
import style from './style.module.less'
import { hashHistory } from 'react-router'

const List = ({ list = [], theme }) => {
  console.log(list)
  const getMediaUrl = inspirations => {
    const type = inspirations[0]?.media?.type
    const media = inspirations[0]?.media
    return type == 1
      ? media.photo?.image_path
      : media.video?.origin_path + '?vframe/jpg/offset/0'
  }

  const getMediaType = inspirations => {
    return inspirations[0]?.media?.type
  }

  return (
    <div style={{ background: theme.dynamicBg }} className={style.list}>
      {list.length ? (
        <>
          <ul className={style.waterfall}>
            {list.map(item => (
              <li key={item.id} className={style.item}>
                <div className={style.top}>
                  <div className={style.img}>
                    <img src={getMediaUrl(item.inspirations)} width="100%" />
                  </div>
                  {!!item.is_top && <span className={style.hot}>置顶</span>}
                  {getMediaType(item.inspirations) == 2 && (
                    <img
                      className={style.player}
                      src="https://qnm.hunliji.com/Fs4ZILrzGFw5bA6onMY-ymOsnXrp"
                      width="18px"
                      height="18px"
                    />
                  )}
                </div>
                <div className={style.bottom}>
                  <p className={style.title}>{item.title}</p>
                  <div className={style.like}>
                    <span>{item.like_count}</span>
                    <img
                      style={{ marginRight: 2 }}
                      src="https://qnm.hunliji.com/FgRzkhtlm3r3U95fmzGUTZmC3rlz"
                      width="12px"
                      height="12px"
                    />
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <div
            onClick={() => {
              hashHistory.push('localMerchant/creation')
            }}
            className={style.more}
          >
            查看全部{' >'}
          </div>
        </>
      ) : (
        <div className={style.none}>暂无动态，快去发布吧~</div>
      )}
    </div>
  )
}

export default List
